import React from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { shallowEqual, useSelector } from 'react-redux';

import { Alert } from 'antd';

import CLIENT from '../../../client/actionTypes';
import FormPassword from './FormPassword';
import FormSendCode from './FormSendCode';

import { ReduxState } from '../../../../types/app';

function formatError(err: string, intl: IntlShape) {
  if (err[0] === '{') {
    const { key, values = {} } = JSON.parse(err);

    return intl.formatMessage(
      {
        id: `error.${key}`,
      },
      values
    );
  }

  return intl.formatMessage({
    id: `error.${err}`,
    defaultMessage: err,
  });
}

type Props = {
  currentEmail?: string;
};

const RecoveryPassword = ({ currentEmail }: Props) => {
  const intl = useIntl();

  const { sendCodeReadyStatus, changePasswordReadyStatus, err, email } =
    useSelector(
      (state: ReduxState) => ({
        sendCodeReadyStatus: state.ClientRecoveryPassword.sendCodeReadyStatus,
        changePasswordReadyStatus:
          state.ClientRecoveryPassword.changePasswordReadyStatus,
        err: state.ClientRecoveryPassword.err,
        email: state.ClientRecoveryPassword.email,
      }),
      shallowEqual
    );

  return (
    <div className="profile-recovery">
      <h3 className="profile-recovery__title">
        {intl.formatMessage({ id: 'client.recoveryPassword.title' })}
      </h3>

      {sendCodeReadyStatus === CLIENT.RECOVERY_PASSWORD.SEND_CODE.SUCCESS &&
        changePasswordReadyStatus !==
          CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.SUCCESS && (
          <Alert
            showIcon
            type="success"
            className="profile-recovery__alert"
            title={intl.formatMessage({ id: 'client.recoveryPassword.sent' })}
          />
        )}

      {changePasswordReadyStatus ===
        CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.SUCCESS && (
        <Alert
          showIcon
          type="success"
          className="profile-recovery__alert"
          title={intl.formatMessage({
            id: 'client.recoveryPassword.success',
          })}
        />
      )}

      {err && (
        <Alert
          showIcon
          type="error"
          className="profile-recovery__alert"
          title={formatError(err, intl)}
        />
      )}

      {sendCodeReadyStatus !== CLIENT.RECOVERY_PASSWORD.SEND_CODE.SUCCESS && (
        <FormSendCode readyStatus={sendCodeReadyStatus} email={currentEmail} />
      )}

      {sendCodeReadyStatus === CLIENT.RECOVERY_PASSWORD.SEND_CODE.SUCCESS &&
        changePasswordReadyStatus !==
          CLIENT.RECOVERY_PASSWORD.CHANGE_PASSWORD.SUCCESS &&
        email && (
          <FormPassword readyStatus={changePasswordReadyStatus} email={email} />
        )}
    </div>
  );
};

export default RecoveryPassword;
